import React from 'react';

const SvgTick = props => (
  <svg
    width={11}
    height={9}
    viewBox="0 0 11 9"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="M.127 4.95A.502.502 0 0 1 0 4.635c0-.09.042-.225.127-.315l.592-.63c.17-.18.423-.18.593 0l.042.045L3.68 6.39c.084.09.211.09.296 0L9.647.135h.041c.17-.18.424-.18.593 0l.592.63c.17.18.17.45 0 .63l-6.77 7.47A.374.374 0 0 1 3.809 9a.374.374 0 0 1-.296-.135l-3.3-3.78-.085-.135z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgTick;
